import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { AssistanceTicketSvc } from '../services/assistance-ticket.service';

@Injectable()
export class AssistanceTicketsTypesService {
  types: any[];
  private subject = new Subject<any>();
  constructor( public ticketSvc: AssistanceTicketSvc) {
    this.types = [
      {
        label: 'Assign Service',
        value: 1,
        icon: '<i class="fa fa-phone" aria-hidden="true"></i>',
      },
      {
        label: 'Assign Provider',
        value: 2,
        icon: '<i class="fa fa-sign-out" aria-hidden="true"></i>',
      },
      {
        label: 'Notify to customer',
        value: 3,
        icon: '<i class="fa fa-users" aria-hidden="true"></i>',
      },
      {
        label: 'Provider Arrived',
        value: 4,
        icon: '<i class="fa fa-user" aria-hidden="true"></i>',
      },
      {
        label: 'Arrival registered from the app',
        value: 50,
        icon: '<i class="fa fa-user" aria-hidden="true"></i>',
      },
      {
        label: 'Closed',
        value: 5,
        icon: '<i class="fa fa-times-circle" aria-hidden="true"></i>',
      },
      {
        label: 'Canceled by Supervisor',
        value: 6,
        icon: '<i class="fa fa-times-circle" aria-hidden="true"></i>',
      },
      {
        label: 'Canceled by Client',
        value: 7,
        icon: '<i class="fa fa-times-circle" aria-hidden="true"></i>',
      },
      {
        label: 'Canceled by Provider',
        value: 8,
        icon: '<i class="fa fa-times-circle" aria-hidden="true"></i>',
      },
      {
        label: 'Comment',
        value: 9,
        icon: '<i class="fa fa-times-circle" aria-hidden="true"></i>',
      },
      {
        label: 'Canceled by Client, Without Cost',
        value: 10,
        icon: '<i class="fa fa-times-circle" aria-hidden="true"></i>',
      },
      {
        label: 'Service not provided',
        value: 27,
        icon: '<i class="fa fa-times-circle" aria-hidden="true"></i>',
      },
      {
        label: 'Programmed',
        value: 11,
        icon: '<i class="fa fa-times-circle" aria-hidden="true"></i>',
      },
      {
        label: 'Connection',
        value: 12,
        icon: '<i class="fa fa-times-circle" aria-hidden="true"></i>',
      },
      {
        label: 'Evaluation Stage',
        value: 13,
        icon: '<i class="fa fa-sign-out" aria-hidden="true"></i>',
      },
      {
        label: 'Service by reimbursement',
        value: ticketSvc.CANCELED_SERVICE_BY_REIMBURSEMENT,
        icon: '<i class="fa fa-sign-out" aria-hidden="true"></i>',
      },
      {
        label: 'Cabin Exception',
        value: ticketSvc.CABIN_EXCEPTION,
        icon: '<i class="fa fa-times-circle" aria-hidden="true"></i>',
      },
       {
        label:  'Exception Authorization',
        value: ticketSvc.CABIN_EXCEPTION_AUTHORIZE,
        icon: '<i class="fa fa-times-circle" aria-hidden="true"></i>',
      },
      {
        label: 'Pronto Pago',
        value: ticketSvc.PRONTO_PAGO,
        icon: '<i class="fa fa-usd" aria-hidden="true"></i>',
      },
      {
        label: 'Asignar a Líder de RED',
        value: ticketSvc.ASSIGN_RED_LEADER,
        icon: '<i class="fa fa-user-plus" aria-hidden="true"></i>',
      },
      {
        label: 'Formulario Pronto Pago',
        value: ticketSvc.PRONTO_PAGO_FORM,
        icon: '<i class="fa fa-file-text-o" aria-hidden="true"></i>',
      },
      {
        label: 'Factura Aprobada',
        value: ticketSvc.APPROVED_INVOICE,
        icon: '<i class="fa fa-check-square-o" aria-hidden="true"></i>',
      },
      {
        label: 'Asignar a Contador',
        value: ticketSvc.ASSIGN_ACCOUNTANT,
        icon: '<i class="fa fa-user-plus" aria-hidden="true"></i>',
      },
      {
        label: 'Registrar Caso',
        value: ticketSvc.REGISTER_CASE,
        icon: '<i class="fa fa-archive" aria-hidden="true"></i>',
      },
      {
        label: 'Pago Solicitado',
        value: ticketSvc.REQUESTED_PAYMENT,
        icon: '<i class="fa fa-paper-plane-o" aria-hidden="true"></i>',
      },
      {
        label: 'Pago Realizado',
        value: ticketSvc.MADE_PAYMENT,
        icon: '<i class="fa fa-money" aria-hidden="true"></i>',
      },
      {
        label: 'Comprobante Enviado',
        value: ticketSvc.RECEIPT_SENT,
        icon: '<i class="fa fa-envelope-o" aria-hidden="true"></i>',
      },
      {
        label: 'Asignar a Supervisor',
        value: ticketSvc.REIMBURSEMENT_ASSIGN_SUPERVISOR,
        icon: '<i class="fa fa-user-plus" aria-hidden="true"></i>',
      },
      {
        label: 'Registro de Solicitud Reembolso',
        value: ticketSvc.REIMBURSEMENT_REGISTER_REQUEST,
        icon: '<i class="fa fa-file-text-o" aria-hidden="true"></i>',
      },
      {
        label: 'Autorización Reembolso',
        value: ticketSvc.REIMBURSEMENT_AUTHORIZATION,
        icon: '<i class="fa fa-check-square-o" aria-hidden="true"></i>',
      },
      {
        label: 'Pago Solicitado Reembolso',
        value: ticketSvc.REIMBURSEMENT_REQUEST_PAYMENT,
        icon: '<i class="fa fa-paper-plane-o" aria-hidden="true"></i>',
      },
      {
        label: 'Pago Realizado Reembolso',
        value: ticketSvc.REIMBURSEMENT_MADE_PAYMENT,
        icon: '<i class="fa fa-money" aria-hidden="true"></i>',
      },
      {
        label: 'Notificar al Cliente Reembolso',
        value: ticketSvc.REIMBURSEMENT_NOTIFY_CUSTOMER,
        icon: '<i class="fa fa-envelope-o" aria-hidden="true"></i>',
      },
      {
        label: 'Cierre de Caso Reembolso',
        value: ticketSvc.REIMBURSEMENT_CLOSE_CASE,
        icon: '<i class="fa fa-archive" aria-hidden="true"></i>',
      },
    ];
  }

  getTypes(): any[] {
    return this.types;
  }

  getTypeLabels(types): string[]{
    let labels: string[] = [];

    for (let type of types) {
      if (type.label) {
        labels.push(type.label);
      }
    }

    return labels;
  }

  sendServiceID(service_id: number) {
    this.subject.next({ serviceid: service_id });
  }

  clearServiceID() {
    this.subject.next(0);
  }

  getServiceID(): Observable<any> {
    return this.subject.asObservable();
  }
}
